import React from 'react'

import { BASE_URL, ICONS } from '../../constants'

import { useAILayer } from '../../aiLayers/hooks'
import { useAIFetch } from '../../ai/hooks'
import { useBuffer } from '../hooks'

import AIList from '../../ai/components/AIList'

import styles from './BufferList.module.css'

const preventClickThru = (onClick) => (e) => {
  if (e) {
    if (e.stopPropagation) {
      e.stopPropagation()
    }
    if (e.nativeEvent && e.nativeEvent.stopImmediatePropagation) {
      e.nativeEvent.stopImmediatePropagation()
    }
  }
  onClick()
}

const BufferListItem = ({ layerId }) => {
  const [
    buffer,
    { hover, endHover, show, hide, edit, select, deselect },
  ] = useBuffer(layerId)
  const layer = useAILayer(layerId)
  const [{ ai, isLoading }, { refresh, cancel }] = useAIFetch(buffer, layer)

  return (
    <div>
      <div
        className={buffer.isSelected ? styles.aiLayerSelected : styles.aiLayer}
        onClick={buffer.isSelected ? deselect : select}
        onMouseEnter={hover}
        onMouseLeave={endHover}
      >
        {!isLoading && ai && ai.length >= 0 && (
          <span className={styles.count}>{ai.length}</span>
        )}
        <span
          className={
            buffer.isVisible ? styles.visibility : styles.visibilityHidden
          }
          onClick={
            buffer.isVisible ? preventClickThru(hide) : preventClickThru(show)
          }
        >
          {buffer.isVisible ? (
            <i className="fa fa-eye"></i>
          ) : (
            <i className="fa fa-eye-slash"></i>
          )}
        </span>
        <span className={styles.editButton} onClick={preventClickThru(edit)}>
          <i className="fa fa-pencil-alt"></i>
        </span>
        {isLoading ? (
          <span
            className={styles.loadingIcon}
            onClick={preventClickThru(cancel)}
          >
            <i className="fa fa-spin fa-spinner"></i>
          </span>
        ) : (
          <span
            className={styles.loadingIcon}
            onClick={preventClickThru(refresh)}
          >
            <i className="fa fa-sync"></i>
          </span>
        )}
        <img
          src={BASE_URL + ICONS.AI.BORDERLESS.DIR + layer.icon}
          alt={layer.iconAlt}
        />
        <div className={styles.layerTitle}>{layer.name}</div>
      </div>
      {buffer.isSelected && <AIList ai={ai || []} layerId={layerId} />}
    </div>
  )
}

export default BufferListItem
